var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "input grid__cell",
      class: [_vm.inputClasses]
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertIsVisible,
              expression: "alertIsVisible"
            }
          ],
          staticClass: "input__alerts"
        },
        [
          _c(
            "div",
            { staticClass: "input__icon" },
            [_c("svgicon", { attrs: { name: "alert-circle" } })],
            1
          ),
          _c("div", { staticClass: "input__alerts__wrapper" }, [
            _c(
              "div",
              _vm._l(_vm.validationErrors, function(error) {
                return _c("p", { staticClass: "input__alerts__text" }, [
                  _vm._v(_vm._s(error.description))
                ])
              }),
              0
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }